import React from 'react';
import { MotifVerticalNavigationMenuItem } from '@ey-xd/motif-react';

interface VerticalNavigationMenuItemProps {
    title?: string;
    child?: string;
    className?: string;
    icon?: React.ReactNode;
    selected?: boolean;
    children?: React.ReactNode;
    label?: string;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}
const VerticalNavigationMenuItem: React.FC<VerticalNavigationMenuItemProps> = (
    props: VerticalNavigationMenuItemProps
) => {
    return <MotifVerticalNavigationMenuItem {...props}></MotifVerticalNavigationMenuItem>;
};

export default VerticalNavigationMenuItem;
